import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import './api/index'
import './tools/'
import './assets/css/reset.css'
// import '../theme/index.css'
import ElementUI from 'element-ui'
import './element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/font/iconfont.css'
import plugin from './plugin/index'






Vue.use(ElementUI)
Vue.use(plugin)
Vue.config.productionTip = false

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vue
